import React from "react";

interface Props {
  children: React.ReactNode;
  styles?: string;
}
function Card({ children, styles }: Props) {
  return (
    <div
      className={`flex rounded-md bg-white outline outline-2 outline-gray-100 ${
        styles || ""
      }`}
    >
      {children}
    </div>
  );
}

export default Card;
